<app-my-order-details *ngIf="selectedOrderId" [orderId]="selectedOrderId" (back)="closeOrderDetails()"></app-my-order-details>

<div id="myorder-container" *ngIf="!selectedOrderId">
    <div class="orders-container-title">Orders History</div>
    <ngx-spinner type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;"></ngx-spinner>
    <div *ngFor="let item of userOrdersResult.data">
        <app-order-card
            [order]="item"
            (details)="openDetails($event)"
            (actionCompleted)="handleSuccessRefresh()"
            (payment)="openPayment($event)">
        </app-order-card>
    </div>

    <div *ngIf="(userOrdersResult.prev_page_url != null || userOrdersResult.next_page_url != null) && !loading" style="display: flex; align-items: center; margin-top: 15px;">
        <div class="text-black pi pi-angle-double-left" style="font-size: 2rem; cursor: pointer;" *ngIf="userOrdersResult.prev_page_url != null" (click)="previousOrders()"></div>
        <div class="text-black pi pi-angle-double-right" style="font-size: 2rem; cursor: pointer; margin-left: auto;" *ngIf="userOrdersResult.next_page_url != null" (click)="nextOrders()"></div>
    </div>
</div>







<p-dialog [draggable]="false" [resizable]="false" [(visible)]="paymentPopUpVisibility" [breakpoints]="{ '979px': '90vw' }" [styleClass]="'custom-dialog'" [style]="{ width: '40%', height: '60%' }" >
    <ng-template pTemplate="header">
        <div class="mt-4 align-items-center justify-content-center w-100 text-center">
            <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">Payment</span>
        </div>
    </ng-template>
    <div id="layoutHome" class="web-center">
        <div style="width: 85%;">
            <div class="w-100 row mt-4 row mb-5" style="max-width: 100%;">
                <form novalidate [formGroup]="stripeTest" class="fm-rubik">
                    <div class="col-md-12 w-100">
                        <div>
                            <input type="text" formControlName="name" class="p-2 payment-input w-100 weight-200" placeholder="Full Name" />
                        </div>
                    </div>
                </form>
                <div style="margin-top: 20px;">
                    <ngx-stripe-card class="mb-4 mt-4" [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-custom" *ngIf="to_pay">
        <div style="display: flex; justify-content: space-between; padding: 5px; margin-right: 5px; align-items: center;">
            <div style="display: flex; align-items: center;">

            </div>
            <div style="display: flex; align-items: center;">
                <div style="display: flex; flex-direction: column;" [style]="isMobile ? 'font-size: 13px;' : 'font-size: medium;'">
                    <span>You pay:</span>
                    <span class="weight-500 fm-rubik" style="font-weight: 500;color: #2C2C30;">£{{to_pay.amount}}</span>
                </div>
                <div style="width: 20px;"></div>
                <div>
                    <app-orange-button [text]="'Pay'" (action)="pay()" [size]="'md'"></app-orange-button>
                </div>
            </div>
        </div>
    </div>
</p-dialog>


